import { v4 as uuidv4 } from 'uuid';

export function MinicartCheckoutButton(props = {}, childrenComponents = [], blocks = []) {
	return {
		componentName: 'MinicartCheckoutButton',
		componentId: uuidv4(),
		props: Object.assign(
			{
				finishShoppingButtonLink: '/checkout/#/cart',
			},
			props,
		),
		childrenComponents,
	};
}
